module.exports = __webpack_public_path__ + "static/media/svg-4.48500b77.svg";